import { render, staticRenderFns } from "./PainelRanking.vue?vue&type=template&id=7a7d1cdf&scoped=true"
import script from "./PainelRanking.vue?vue&type=script&lang=js"
export * from "./PainelRanking.vue?vue&type=script&lang=js"
import style0 from "./PainelRanking.vue?vue&type=style&index=0&id=7a7d1cdf&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7d1cdf",
  null
  
)

export default component.exports